import { useRef, useState } from 'react';
import constate from 'constate';
import { StoryBoardTracks } from 'services/storyboard.service';

interface DndRange {
  index: Index;
  length: number;
  clips: CellClip[];
  originRange: GroupRange;
}

export interface GroupRange {
  track: StoryBoardTracks;
  from: Index;
  to: Index;
}

const useSbDndProvider = () => {
  const dndRange = useRef<DndRange | null>(null);
  const [isDragging, setIsDragging] = useState(false);
  const [targetRange, setTargetRange] = useState<GroupRange | null>(null);
  return { dndRange, targetRange, setTargetRange, isDragging, setIsDragging };
};

export const [SbDndProvider, useSbDndContext] = constate(useSbDndProvider);
